module.exports = __webpack_public_path__ + "media/icons/e-dark-b7d607bc.svg";